/**
 * @generated SignedSource<<3ca68abcb37d7d1feba5632d379b2399>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleHistoryDetailTitle_teamSchedule$data = {
  readonly id: string;
  readonly label: string;
  readonly " $fragmentType": "TeamScheduleHistoryDetailTitle_teamSchedule";
};
export type TeamScheduleHistoryDetailTitle_teamSchedule$key = {
  readonly " $data"?: TeamScheduleHistoryDetailTitle_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHistoryDetailTitle_teamSchedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleHistoryDetailTitle_teamSchedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    }
  ],
  "type": "TeamSchedule",
  "abstractKey": null
};

(node as any).hash = "18a96438aed95e199afd5e59e42e5a74";

export default node;
